import _ from 'underscore';
import { getFinalUrlWithPath } from '@bingads-webui-campaign-react/validated-url-input';
import { AdPreviewSurfacePlacementKeys } from '../const';

export const getPlacementFilterBySurface = (surface) => {
  const placementKeys = AdPreviewSurfacePlacementKeys[surface];

  return ({ key }) => _.contains(placementKeys, key);
};

export const getNumberOfPlacementBySurface = surface =>
  AdPreviewSurfacePlacementKeys[surface].length;

export const getAdDataFromAssetGroupData = (assetGroupData, previewTextAssets) => {
  let previewHeadline = 'Headline0';
  let previewLongHeadline = 'LongHeadline0';
  let previewDescription = 'Description0';
  // Make sure previewTextAssets is not deleted
  if (!_.isUndefined(_.get(assetGroupData, ['Headlines', previewTextAssets.Headlines]))) {
    previewHeadline = previewTextAssets.Headlines;
  }
  if (!_.isUndefined(_.get(assetGroupData, ['LongHeadlines', previewTextAssets.LongHeadlines]))) {
    previewLongHeadline = previewTextAssets.LongHeadlines;
  }
  if (!_.isUndefined(_.get(assetGroupData, ['Descriptions', previewTextAssets.Descriptions]))) {
    previewDescription = previewTextAssets.Descriptions;
  }

  return {
    url: _.get(assetGroupData, ['FinalUrls', 0]),
    displayUrl: getFinalUrlWithPath(_.get(assetGroupData, ['FinalUrls'], [])),
    shortHeadline: _.get(assetGroupData, ['Headlines', previewHeadline]),
    longHeadline: _.get(assetGroupData, ['LongHeadlines', previewLongHeadline]),
    description: _.get(assetGroupData, ['Descriptions', previewDescription]),
    businessName: _.get(assetGroupData, ['BusinessName']),
  };
};

export const getImagesToDisplay = (imageList, selectedImageId) =>
  _.find(imageList, (placementList) => {
    const {
      id, idString, baseId, baseImage,
    } = _.first(placementList) || {};
    const { id: baseImageId, idString: baseImageIdString } = baseImage || {};
    return id === selectedImageId
      || idString === selectedImageId
      || baseId === selectedImageId
      || baseImageId === selectedImageId
      || baseImageIdString === selectedImageId;
  });
